export const workflowSteps = [
  {
    number: '1',
    title: 'Organize content',
    tools: ['CMS'],
    body: 'The CMS manages structured content, publishing, editorial workflows, and user experiences. Research papers, program materials, and policy documents enter the semantic workflow with their source and version information intact.',
    note: '',
  },
  {
    number: '2',
    title: 'Extract and propose',
    tools: ['Biomedical NLP', 'LLM'],
    body: 'Biomedical tools and an LLM analyze a paper and propose entities and relationships: an organism, condition, intervention, study population, outcome, and the passage supporting a finding.',
    note: 'For NCJI material, the workflow can propose connections among a capability, observable indicator, assessment task, rubric, development activity, and supporting research.',
  },
  {
    number: '3',
    title: 'Reconcile and review',
    tools: ['VocBench', 'Validation rules', 'Human review'],
    body: 'VocBench maintains governed vocabularies and ontology definitions. The custom workflow matches proposed terms to approved identifiers, checks relationships against validation rules, and routes uncertain or consequential claims to human reviewers.',
    note: '',
  },
  {
    number: '4',
    title: 'Connect and retrieve',
    tools: ['GraphDB', 'Semantic search', 'GraphRAG'],
    body: 'GraphDB stores approved relationships and their provenance. Search combines document text, shared concepts, and graph relationships. GraphRAG uses those approved connections to produce answers that point back to the evidence used.',
    note: '',
  },
]

export const reviewActions = ['Accept', 'Revise', 'Reject', 'Request more evidence']

export const researchTrace = [
  { label: 'Intervention', value: 'Which studies examined it?' },
  { label: 'Populations', value: 'In which study populations?' },
  { label: 'Outcomes', value: 'With what reported outcomes?' },
  { label: 'Evidence', value: 'The relevant paper and passage' },
]

export const capabilityChain = [
  'Capability domain',
  'Indicators',
  'Assessment tasks',
  'Interpretation rules',
  'Learning activities',
  'Later outcomes',
]

export const developmentCycle = [
  { title: 'Identify', body: 'An area for growth' },
  { title: 'Explain', body: 'The finding and its grounds' },
  { title: 'Recommend', body: 'A development pathway' },
  { title: 'Measure', body: 'Progress over time' },
]

export const constitutionalControls = [
  {
    title: 'Documented grounds',
    body: 'Preserve the observations, rules, evidence, and versions behind a finding.',
  },
  {
    title: 'Human authority',
    body: 'Require authorized review before a consequential assessment or policy change takes effect.',
  },
  {
    title: 'Appeal and correction',
    body: 'Record challenges, independent reviews, corrections, and affected downstream results.',
  },
  {
    title: 'Reassessment and restoration',
    body: 'Support updated findings and renewed access when demonstrated improvement or correction warrants it.',
  },
  {
    title: 'Proportionate access',
    body: 'Limit who can view sensitive records or take particular actions, with an audit trail for each use.',
  },
  {
    title: 'Policy versioning',
    body: 'Show which approved policy governed a decision at the time it was made.',
  },
]

export const traceability = [
  { from: 'A scientific finding', to: 'the study behind it' },
  { from: 'An NCJI interpretation', to: 'the task and rubric' },
  { from: 'A development recommendation', to: 'an approved rule and supporting evidence' },
]

export const semanticCapabilities = [
  {
    title: 'Structured content',
    body: 'Research, records, and publications organized into a consistent, queryable structure instead of scattered documents.',
  },
  {
    title: 'Shared concepts',
    body: 'A defined vocabulary of concepts and relationships so teams describe the same ideas in the same way.',
  },
  {
    title: 'Connected evidence',
    body: 'Claims linked back to their sources, so any finding can be traced, checked, and compared.',
  },
  {
    title: 'Knowledge graphs',
    body: 'Studies, researchers, institutions, and findings represented as a navigable network of relationships.',
  },
  {
    title: 'Semantic search',
    body: 'Search by meaning and relationship, not just keywords, to surface related evidence people would otherwise miss.',
  },
  {
    title: 'AI-assisted research with expert review',
    body: 'AI-assisted discovery that proposes connections, paired with expert review that keeps the knowledge base trustworthy.',
  },
]
